export default "__VITE_ASSET__CpgRVwZ6__"